import React from 'react';
import Aux from '../../hoc/Aux';
import { URLS } from '../../urls';
import i18n from 'i18next';

const LogoDescriptionTable = (props) => {

  const logos = props.logos || []

  return (
    <dl className="row logos">
      { logos.map( (s) => <Aux><dt className="col-sm-4 col-md-3"><img key={s.id} style={{height: "60px", paddingRight: "20px"}} alt='' src={URLS['BACKEND'] + '/' + s.image_url} /></dt>
                    <dd className="col-sm-8 col-md-9" dangerouslySetInnerHTML={{ __html: s.text[i18n.language] }}/></Aux> )
      }
    </dl>
  )
};

export default LogoDescriptionTable;



// WEBPACK FOOTER //
// ./src/components/Shared/LogoDescriptionTable.js